var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetedTalent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 104.814,
    height: 110.919,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-506 -1409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(511 1411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M43.865,67.053a17.084,17.084,0,0,0-25.187,23.04l-4.332,4.336L12.693,92.78,1.124,104.355a3.851,3.851,0,0,0,0,5.439l0,0a3.859,3.859,0,0,0,5.443,0L18.147,98.219,16.5,96.573l4.332-4.332A17.083,17.083,0,0,0,43.865,67.053ZM40.2,87.546a11.888,11.888,0,1,1,0-16.818,11.813,11.813,0,0,1,0,16.818",
    fill: "#3526ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M12.868,63.037a1.56,1.56,0,0,1-1.275,1.8,1.585,1.585,0,0,1-.264.022,1.561,1.561,0,0,1-1.536-1.3,48.373,48.373,0,0,1-.685-8.11A47.877,47.877,0,0,1,39.676,10.82,1.56,1.56,0,0,1,40.8,13.728,44.8,44.8,0,0,0,12.868,63.037ZM96.238,28.11A47.766,47.766,0,0,0,74.252,10.82a1.559,1.559,0,0,0-1.127,2.908A44.745,44.745,0,0,1,46.708,99a1.559,1.559,0,1,0-.713,3.036A48.033,48.033,0,0,0,56.964,103.3,47.856,47.856,0,0,0,96.238,28.11ZM74.787,30.065a9.9,9.9,0,0,0-8.437,4.742,14.125,14.125,0,0,1,4.3,14.1,9.877,9.877,0,1,0,4.136-18.845Zm3.194,43.256a31.555,31.555,0,0,0,12.945-4V65.637a12.713,12.713,0,0,0-12.7-12.7H71.352a12.571,12.571,0,0,0-2.639.283,14.206,14.206,0,0,1-3.639,3.715A17.274,17.274,0,0,1,77.981,73.321M56.964,56.387A11.021,11.021,0,1,0,45.948,45.368,11.029,11.029,0,0,0,56.964,56.387m-9.385-21.58a9.882,9.882,0,1,0-4.3,14.1,14.125,14.125,0,0,1,4.3-14.1Zm4.414,44.334a20.325,20.325,0,0,1-.207,2.908,38.562,38.562,0,0,0,5.178.35,35.478,35.478,0,0,0,17.905-4.626V73.628A14.14,14.14,0,0,0,60.746,59.505H53.182a14.092,14.092,0,0,0-9.254,3.483,20.2,20.2,0,0,1,8.065,16.153ZM45.215,53.222a12.563,12.563,0,0,0-2.639-.283H35.7a12.8,12.8,0,0,0-11.579,7.5,20.305,20.305,0,0,1,17.081.815,17.28,17.28,0,0,1,7.664-4.312A14.318,14.318,0,0,1,45.215,53.222Zm.232-42.747,5.443,4.171-1.955,6.578a1.56,1.56,0,0,0,2.38,1.729l5.65-3.893,5.649,3.893a1.56,1.56,0,0,0,2.38-1.729l-1.955-6.578,5.443-4.171a1.56,1.56,0,0,0-.909-2.8L60.717,7.5,58.435,1.041A1.561,1.561,0,0,0,56.965,0h0a1.559,1.559,0,0,0-1.47,1.04L53.206,7.5l-6.851.175a1.559,1.559,0,0,0-.908,2.8Z",
    fill: "#281260"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 114,
    height: 114,
    transform: "translate(506 1409)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetedTalent);
export default __webpack_public_path__ + "static/media/targeted-talent.4b50c158962aea5a3117353474445682.svg";
export { ForwardRef as ReactComponent };